import React, { cloneElement } from 'react';
import { AppBar, Box } from '@mui/material';
import { Toolbar } from '@mui/material';
import useScrollTrigger from '@mui/material/useScrollTrigger';


const ElevationScroll = (props) => {
    const { children } = props;

    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
    });

    return cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });

};

const NavMenu = (props) => {

    return (
        <header className="NavHeader">
            <Box sx={{ flexGrow: 1 }}>
                <ElevationScroll {...props}>
                    <AppBar>
                        <Toolbar style={{minHeight: 72}}>
                            {props.children}
                        </Toolbar>
                    </AppBar>
                </ElevationScroll>
            </Box>
        </header>
    );
};

export { NavMenu };